import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import config from "csi/config";
import { Actions } from "csi/def/Actions";
import { View } from "csi/def/View";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const MassDeleteDimensions = declare(Controller, {

	addProxyActions(defView: View, defActions: Actions): void {
		const sizeChart = this.getCache().getPathNode(this.m_urlParent, "Child:__Parent__");
		const lockShapeDimensionList = config.getSubtypeSetting(sizeChart?.Subtype, "LockShapeDimensionList");

		if (!lockShapeDimensionList && sizeChart.StyleSizeCharts.length > 0) {
			defActions.addAction(this.getProxyAction("BUTTON_UNLINK_AND_DELETE", true));
		} else {
			defActions.addAction(this.getProxyAction("BUTTON_DELETE", true));
		}
		this.inherited(arguments);
	},

	process(): void {
		const urls = this.m_formData.getSelectedValue();
		const req = this.m_action.m_request;
		this.setProgress();
		new PostRequest(req.m_module, req.m_operation)
			.addParameter("ParentURL", this.m_urlParent)
			.addParameter("URLs", urls)
			.post({})
			.then(lang.hitch(this, this._onPublishResponse));
	},
});

export = MassDeleteDimensions;
